module.exports = __webpack_public_path__ + "img/chun.6b02c0ce.png";